import styled from "@emotion/styled";
import { darkGrey2, lightGreen } from "@stepfinance/react";
import { Button } from "antd";
import type { BaseButtonProps } from "antd/lib/button/button";
import React from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

export const headerButtonStyles = `
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 32px;
  max-width: 32px;
  height: 32px;
  padding: 0;
  background: ${darkGrey2};
  border-radius: 8px;
  border: 1px solid ${darkGrey2};

  svg, [aria-label='Countdown timer'] {
    margin: 0 auto;
    pointer-events: none;
  }
  &:hover {
    -webkit-appearance: none;
    background: ${darkGrey2};
  }
  &:active, &:focus {
    border: 1px ${lightGreen} solid;
  }
  &:hover, &:focus, &:active {
    color: ${lightGreen}
  }
`;

interface IProps {
  isVisible: boolean;
  refreshContext: boolean;
  refreshContexts: () => void;
  refreshDisabled: boolean;
  timerKey: number;
}

const REFRESH_TIMEOUT = 120;

export const RefreshButton: React.FC<IProps> = ({
  isVisible,
  refreshContext,
  refreshContexts,
  refreshDisabled,
  timerKey,
}) => {
  return (
    <StyledRefreshButton type="default" onClick={refreshContexts} disabled={refreshContext}>
      <CountdownCircleTimer
        key={timerKey}
        isPlaying={isVisible && !refreshContext && !refreshDisabled}
        duration={REFRESH_TIMEOUT}
        onComplete={() => {
          refreshContexts();
          return {
            delay: timerKey,
            shouldRepeat: true,
          };
        }}
        colors={refreshContext ? "#aaa" : lightGreen}
        size={16}
        strokeWidth={2}
      />
    </StyledRefreshButton>
  );
};

const StyledRefreshButton = styled(Button)<BaseButtonProps>`
  ${headerButtonStyles}
  > * {
    margin: auto;
  }
`;
